import { GetterTree } from 'vuex';
import { ApplicationFormTemplateState } from './types';
import { RootState } from '../../types';

const getApplicationTemplateCount = state => (): number => state.templateCount;

export const getters: GetterTree<ApplicationFormTemplateState, RootState> = {
    count: state => getApplicationTemplateCount(state),
};
